<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<Props>()
const mainStore = useMainStore()
interface Props {
  class?: HTMLAttributes['class']
}

const baseClass = 'w-full flex items-center flex-wrap gap-1 btn btn-lg text-lg md:text-xl font-bold h-full py-4 px-8 button-getmoney button-shadow text-h1 flex items-center justify-center hover:cursor-pointer hover:translate-y-[-0.25rem] transition-transform relative overflow-hidden'
</script>

<template>
  <button :class="cn(baseClass, props.class)" type="button" @click.prevent="mainStore.goToAnketaLink">
    <slot />
  </button>
</template>

<style scoped>
.button-shadow {
    background: linear-gradient(rgb(255, 152, 16), rgb(255, 131, 0));
    box-shadow: rgb(255, 206, 135) 0px 15px 50px -10px;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    color: #fff;
    white-space: normal;
    position: relative;
    overflow: hidden;
}

.button-shadow::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0)
  );
  transform: rotateZ(60deg) translate(-5em, 12em);
  animation: sheen 3s infinite;
  opacity: 0.7;
}

@keyframes sheen {
  100% {
    transform: rotateZ(60deg) translate(100%, -25em);
  }
}
</style>
